<template>
  <div
    aria-modal="true"
    role="dialog"
    tabindex="-1"
    @click.self="close"
  >
    <transition
      name="error-slide"
      @after-leave="onAfterLeaveTransition"
    >
      <component
        ref="content"
        v-show="popup.showContent"
        :is="currentComponent"
        v-bind="popup.props"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "GlobalPopup",
  props:{
    closeButton: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      closeTimeout: null,
      currentComponent: null
    }
  },
  computed: {
    ...mapGetters({popup: 'getPopupInfo'})
  },
  methods:{
    onAfterLeaveTransition() {
      this.$nextTick(this.onClose)
    },
    onClose() {
      const url = new URL(location);
      url.searchParams.delete('error');
      history.pushState(null, document.title, url);
      this.$store.dispatch('closePopup');
    },
    async loadComponent() {
      const module = await import(`@/components/popups/components/${this.popup.component}.vue`);
      this.currentComponent = module.default;
      await this.$nextTick();
      this.$refs['content'].open()
    },
    autoClose(delay = 10000) {
      this.closeTimeout = setTimeout(() => {
        this.$store.dispatch('toggleContent')
      }, delay)
    }
  },
  mounted() {
    this.loadComponent();
    this.autoClose()
  },
  beforeUnmount() {
    clearTimeout(this.closeTimeout)
  }
};
</script>

<style lang="scss" scoped>
.error-slide-enter-active,
.error-slide-leave-active {
  transition: all 0.5s ease;
}

.error-slide-enter-from,
.error-slide-leave-to {
  transform: translate(-50%, -100%);
  opacity: 0;
}

:deep(.error-modal-overlay) {
  background-color: transparent;
}
</style>
